var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "text-center" }, [
    _c("h1", {
      directives: [
        {
          name: "t",
          rawName: "v-t",
          value: "JOIN_INVITE_FAILURE",
          expression: "'JOIN_INVITE_FAILURE'"
        }
      ],
      staticClass: "title md-title"
    }),
    _vm._v(" "),
    _c("p", { staticClass: "subtitle" }, [
      _vm._v("\n    " + _vm._s(_vm.inviteStatus.errorMessage) + "\n  ")
    ]),
    _vm._v(" "),
    _c("a", {
      directives: [
        {
          name: "t",
          rawName: "v-t",
          value: "BACK_LOGIN_LINK",
          expression: "'BACK_LOGIN_LINK'"
        }
      ],
      staticClass: "button button--transparent-grad pulse m-t-20",
      attrs: { href: "#" },
      on: { click: _vm.goToLogin }
    })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }